import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tooltip, Button } from '@material-ui/core';
import { addToMassEdit } from 'redux/actions/products';
import { useHistory } from 'react-router-dom';


const CustomToolbarSelect = ({
  selectedRows,
  productList,
  showActions = {},
  productsType = 'active'
}) => {
  const dispatch = useDispatch();

  const {profile} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};
  const history = useHistory();

  const selectedProdIdx = selectedRows.data.map((row) => row.dataIndex);

  const handleAddToMassEdit = () => {
    const selectedProducts = selectedProdIdx.map((idx) => productList[idx]);
    const list = selectedProducts.map((product) => ({ product }));
    dispatch(addToMassEdit(list, productsType));

    history.push('/store-products/mass-edit');
  };

  return (
    <div>
      {showActions.massEdit && permissions.massEditActive && selectedProdIdx.length > 1 &&
      <Tooltip title={'Add Products to Bulk Edit'} className="mr-2">
        <Button variant="contained" color="primary" onClick={handleAddToMassEdit}>
          Bulk Edit
        </Button>
      </Tooltip>}
    </div>
  );
};

export default CustomToolbarSelect;
